import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JardinModel } from 'src/app/model/Jardin.model';
import { JardinTutoria, ResponseJardinTutoria } from 'src/app/model/JardinTutoria.model';
import { apiService } from 'src/app/service/api.service';
import { StorageService } from 'src/app/service/storage.service';
import { TutoriaService } from 'src/app/service/tutoria.service';
import { JardinComponent } from '../../jardin.component';
import { ModalMediosVerificacionComponent } from '../dialogs/modal-medios-verificacion/modal-medios-verificacion.component';

@Component({
  selector: 'app-autoevaluacion-inicio-view',
  templateUrl: './autoevaluacion-inicio-view.component.html',
  styleUrls: ['./autoevaluacion-inicio-view.component.css']
})
export class AutoevaluacionInicioViewComponent implements OnInit {

  jardinTutoria1 : JardinTutoria = new JardinTutoria();
  jardinTutoria2 : JardinTutoria = new JardinTutoria();
  jardinTutoria3 : JardinTutoria = new JardinTutoria();
  jardinTutoria4 : JardinTutoria = new JardinTutoria();
  responseJardinTutoria : ResponseJardinTutoria = new ResponseJardinTutoria();
  dataJardin = new JardinModel();

  @ViewChild('divSpinner') divSpinner:ElementRef;
  @Input() simulacion: boolean;
  cargando :boolean;
  context: boolean = false;
  
  constructor(
    @Inject(JardinComponent) private parent: JardinComponent,
    public dialog: MatDialog,
    private api: apiService,
    private storageService: StorageService,
    private tutoriaService: TutoriaService,
  ) { }

  ngOnInit(): void {
    this.cargaInicial();
  }
 
  cargaInicial(){
    this.getTutorias(this.storageService.getCurrentUser().idUsuario);
    this.dataJardin = this.api.dataJardin;
  }


  getTutorias(idUsuario:number){
    if(this.simulacion){
      
      this.tutoriaService.API_POST_getTutoriasByIdUsuario(this.api.dataJardin.idUsuario).subscribe((response: ResponseJardinTutoria) => {
        this.responseJardinTutoria = response;
        this.responseJardinTutoria.payload.forEach((tutoria)=>{
          switch (tutoria.numeroTutoria) {
            case 1: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria1 = tutoria;
              this.jardinTutoria1.fechaInicioTutoria = fechaInicio;
              this.jardinTutoria1 = tutoria;
              break;
            }
            case 2: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria2 = tutoria;
              this.jardinTutoria2.fechaInicioTutoria = fechaInicio;
              break;
            }
            case 3: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria3 = tutoria;
              this.jardinTutoria3.fechaInicioTutoria = fechaInicio;
              break;
            }
            case 4: {
              let fechaInicio = new Date(tutoria.fechaInicioTutoria);
              fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
              this.jardinTutoria4 = tutoria;
              this.jardinTutoria4.fechaInicioTutoria = fechaInicio;
              break;
            }           
          }
        });
        this.cargando = false;
        this.divSpinner.nativeElement.style.display='none';
      },
      (err) => {
        console.log(err)
      })
    }else{
      this.tutoriaService.API_POST_getTutoriasByIdUsuario(idUsuario).subscribe((response: ResponseJardinTutoria) => {
        this.responseJardinTutoria = response;
        this.responseJardinTutoria.payload.forEach((tutoria)=>{
          switch (tutoria.numeroTutoria) {
            case 1: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria1 = tutoria;
                this.jardinTutoria1.fechaInicioTutoria = fechaInicio;  
              }else{
                this.jardinTutoria1 = tutoria;
              }
              
              break;
            }
            case 2: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria2 = tutoria;
                this.jardinTutoria2.fechaInicioTutoria = fechaInicio;
              }else{
                this.jardinTutoria2 = tutoria;
              }
              break;
            }
            case 3: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria3 = tutoria;
                this.jardinTutoria3.fechaInicioTutoria = fechaInicio;
              }else{
                this.jardinTutoria3 = tutoria;
              }
              break;
            }
            case 4: {
              if(tutoria.fechaInicioTutoria != null){
                let fechaInicio = new Date(tutoria.fechaInicioTutoria);
                fechaInicio.setTime( fechaInicio.getTime() + fechaInicio.getTimezoneOffset()*60*1000 );
                this.jardinTutoria4 = tutoria;
                this.jardinTutoria4.fechaInicioTutoria = fechaInicio;
              }else{
                this.jardinTutoria4 = tutoria;
              }
              break;
            }           
          }
        });
        this.cargando = false;
        this.divSpinner.nativeElement.style.display='none';
      },
      (err) => {
        console.log(err)
      })
    }
    
  }

  verMediosVerificacion(){
    const dialogRef = this.dialog.open(ModalMediosVerificacionComponent ,{
      disableClose: true ,
      width: '50%',
    });
  }

  irA(){
    // this.api.emitDireccionamiento('autoevaluacion');
    this.parent.menuVisible("autoevaluacion");
  }

  irContexto() {
    this.context = true;
  }

  volver() {
    this.context = false;
  }


}
